import { createSliceWithThunks } from '../helpers';
import { storeName } from './consts';
import reducers from './reducers';
import selectors from './selectors';
import { RecommendationProductsStoreStateInitial } from './types';

const initialState: RecommendationProductsStoreStateInitial =
  {
    loading: 'idle',
    error: null,
    ids: [],
    productsBond: {},
    entities: {}
  };

export const recommendationProductsSlice =
  createSliceWithThunks({
    name: storeName,
    initialState,
    selectors,
    reducers
  });

export const { fetchRecommendationProducts, addToCart } =
  recommendationProductsSlice.actions;

export const {
  selectRecommendationProducts,
  selectRecommendationProductsAnalitics,
  selectRecommendationProduct
} = recommendationProductsSlice.selectors;

export default recommendationProductsSlice.reducer;
